import './App.css';

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { CacheBuster } from './components/react/CacheBuster';
import { SceneViewerRoute } from './routes/SceneViewerRoute';

function App() {
  return (
    <CacheBuster>
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route path="/" component={SceneViewerRoute} />
        </Switch>
      </Router>
    </CacheBuster>
  );
}

export default App;
